import { render } from "./PopperWrapper.vue?vue&type=template&id=08399646"
import script from "./PopperWrapper.vue?vue&type=script&lang=js"
export * from "./PopperWrapper.vue?vue&type=script&lang=js"

import "./PopperWrapper.vue?vue&type=style&index=0&id=08399646&lang=css"

import exportComponent from "D:\\Projects\\jimoty\\JimotyWeb\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__